// Apply to an alliance with an optional message (alliance list and alliance profile).
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { endpoints } from '../../api/endpoints';
import { Button, ErrorNotice, TextField } from '../ui';
import { useRefresh } from './shared';

export function ApplyForm({
  galaxyId,
  allianceId,
  onDone,
}: {
  galaxyId: string;
  allianceId: string;
  onDone: () => void;
}) {
  const refresh = useRefresh(galaxyId);
  const [message, setMessage] = useState('');
  const apply = useMutation({
    mutationFn: () => endpoints.applyToAlliance(galaxyId, allianceId, message.trim()),
    onSuccess: () => {
      onDone();
      refresh();
    },
  });
  return (
    <form
      className="mt-2 space-y-2"
      onSubmit={(e) => {
        e.preventDefault();
        apply.mutate();
      }}
    >
      <TextField
        label="Message to the officers (optional)"
        value={message}
        maxLength={500}
        onChange={(e) => setMessage(e.target.value)}
      />
      {apply.error ? <ErrorNotice error={apply.error} /> : null}
      <div className="flex gap-2">
        <Button type="submit" disabled={apply.isPending}>
          Send application
        </Button>
        <Button variant="ghost" onClick={onDone}>
          Cancel
        </Button>
      </div>
    </form>
  );
}
